@if (!widgetTemplateRef()) {
    @for (entry of widgetLayoutEntries(); track entry.widget.id ?? entry.index) {
        <website-widget-loader
            [widget]="entry.widget"
            [index]="entry.index"
            [hasWrapper]="entry.hasWrapper"
            [hasReducedTopSpacingMobile]="entry.reducedTopSpacing.mobile"
            [hasReducedTopSpacingDesktop]="entry.reducedTopSpacing.desktop"
            [isFiguredBackgroundAllowedMobile]="entry.figuredBackgroundAllowed.mobile"
            [isFiguredBackgroundAllowedDesktop]="entry.figuredBackgroundAllowed.desktop"
            [renderContext]="entry.renderContext"
        ></website-widget-loader>
    }
} @else {
    @for (entry of widgetLayoutEntries(); track entry.widget.id ?? entry.index) {
        <ng-container
            [ngTemplateOutlet]="widgetTemplateRef()"
            [ngTemplateOutletContext]="{
                hasWrapper: entry.hasWrapper,
                hasReducedTopSpacingMobile: entry.reducedTopSpacing.mobile,
                hasReducedTopSpacingDesktop: entry.reducedTopSpacing.desktop,
                isFiguredBackgroundAllowedMobile: entry.figuredBackgroundAllowed.mobile,
                isFiguredBackgroundAllowedDesktop: entry.figuredBackgroundAllowed.desktop,
                widget: entry.widget,
                index: entry.index,
                renderContext: entry.renderContext,
            }"
        ></ng-container>
    }
}
